import Iconify from "../../../components/Iconify";

// ----------------------------------------------------------------------

export default function StateSummaryCard({
  title,
  count,
  icon,
  color = "#000",
  sx,
  ...other
}) {
  return (
    <div
      className="custom-card text-white d-flex flex-wrap align-items-center p-3 h-100 justify-content-between rounded-3 box-shadow-main"
      style={{
        backgroundColor: color,
      }}
    >
      {/* Icon Section */}
      <div className="col-4 col-xl-3">
        <div className="icon-section bg-white">
          <Iconify icon={icon} width={25} height={25} sx={{ color: color }} />
        </div>
      </div>
      {/* Content Section */}
      <div className="content-section text-center col-8 col-xl-9">
        <h5 className="stat-count text-white">
          {typeof count === "number" ? (count > 0 ? count : "0") : count}
        </h5>
        <h6 className="stat-title text-white">{title}</h6>
      </div>
    </div>
  );
}
